import { downloadCarespaceRecords, useCarespaceRecords } from "./carespaceRecords";
import { carespaceRecordUrl } from "./careNavigationUrls";
import { Popover, PopoverPopup, PopoverTrigger } from "../../components/ui/popover";

export function CarespaceCountLink(props: {
  count: number | null;
  recordIds?: string[] | undefined;
  fallbackUrl?: string | undefined;
  label: string;
  preliminary?: boolean;
}) {
  const { filePrefix, records } = useCarespaceRecords();
  if (props.count === null) return <span title="Data unavailable">—</span>;
  if (!props.count) return <span>{props.preliminary ? "0 · Preliminary" : "0"}</span>;
  const links = [...new Set(props.recordIds)].flatMap((id) => {
    const url = carespaceRecordUrl(id);
    return url ? [{ id, url }] : [];
  });
  const exportRecords = links.flatMap(({ id }) => {
    const record = records.get(id);
    return record ? [record] : [];
  });
  return (
    <Popover>
      <PopoverTrigger
        className="cursor-pointer text-primary underline"
        aria-label={`${props.label}: ${props.count}; view CareSpaces`}
      >
        {props.count}
        {props.preliminary ? " · Preliminary" : ""}
      </PopoverTrigger>
      <PopoverPopup>
        <div className="mb-3 flex items-center justify-between gap-4">
          <p className="font-medium">{props.label}</p>
          {links.length > 0 && exportRecords.length === links.length ? (
            <button
              type="button"
              className="shrink-0 rounded-md border px-2 py-1 text-xs"
              onClick={() => downloadCarespaceRecords(exportRecords, props.label, filePrefix)}
            >
              Download CSV
            </button>
          ) : null}
        </div>
        <div className="max-h-64 space-y-2 overflow-auto">
          {links.length ? (
            <p className="text-xs text-muted-foreground">
              Open a CareSpace directly by selecting its link.
            </p>
          ) : null}
          {links.map(({ id, url }) => (
            <a
              key={id}
              className="block text-primary underline"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              title={`Open CareSpace ${id} in Carespaces`}
            >
              CareSpace {id} <span aria-hidden="true">↗</span>
            </a>
          ))}
          {!links.length ? (
            <p className="text-sm text-muted-foreground">
              Record links are unavailable for this count.
            </p>
          ) : null}
          {props.fallbackUrl ? (
            <a
              className="block text-primary underline"
              href={props.fallbackUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              View navigator’s CareSpaces
            </a>
          ) : null}
        </div>
      </PopoverPopup>
    </Popover>
  );
}
